import React, {useEffect, useState} from "react";
import {api} from "../utils/gashtaltAPI";
import Loader from "../components/Loader";
import ErrorPage from "../components/ErrorPage";
import Navbar from "../components/Navbar";
import {Table, TableContainer, Tbody, Td, Thead, Tr} from "@chakra-ui/react";
import {toPersianNumber} from "../utils/numberConversion";
import {useNavigate, useParams} from "react-router-dom";
import FilterTd from "../components/FilterTd";
import DownloadHandler from "../utils/downloadHandler";
import {RiFileExcel2Line} from "react-icons/ri";

function Products() {
    const {Type} = useParams()
    const [products, setProducts] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const response = await api.get('/api/products')
                setProducts(response.data.data);
            } catch (error) {
                setError(error)
                console.log(error)
            } finally {
                setLoading(false);
            }
        }
        fetchData();
    }, []);

    if (loading) return <Loader/>
    if (error) return <ErrorPage error={error}/>;
    return (
        <div className="d-flex flex-column h-100">
            <Navbar/>
            <div className="table-container flex-fill d-flex flex-column justify-content-between"
                 style={{borderTop: '3px solid #EAEAEA'}}>
                <TableContainer>
                    <Table variant='striped' colorScheme='teal'>
                        <Thead>
                            <Tr>
                                <Td>ردیف</Td>
                                <Td>
                                    نام
                                </Td>
                                <Td>نوع محصول</Td>
                                <Td>نمایش</Td>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {products?.map((product, index) => product.product_type!==1 && Type==='Reports' ? (<></>) : (
                                <Tr>
                                    <Td>{toPersianNumber(index + 1)}</Td>
                                    <Td>{product.name}</Td>
                                    <Td>
                                        {product.product_type == 1 && ('آزمون')}
                                        {product.product_type == 3 && ('فایل')}
                                    </Td>
                                    <Td>
                                        <button
                                            className={`btn btn-outline-green`}
                                            onClick={() => {
                                                if (Type === "Invoices")
                                                    navigate(`/${Type}/${product.product_type}/${product.id}`)
                                                if (Type === "Reports")
                                                    navigate(`/${Type}/${product.id}`)
                                            }}>
                                            نمایش
                                        </button>
                                    </Td>
                                </Tr>
                            ))}
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default Products;